import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { MessageRecipient } from 'src/app/core/models/message-recipient.model';
import { Message } from 'src/app/core/models/message.model';
import { ASCII_REMOTE_KEYS } from 'src/app/core/services/remote-control.service';
import { RouterExtensionService } from 'src/app/core/services/router-extension.service';
import { MessagesState } from 'src/app/state/messages.reducer';
import { selectMessageRecipientById } from 'src/app/state/messages.selectors';

@Component({
  selector: 'app-message-history-image-viewer',
  templateUrl: './message-history-image-viewer.component.html',
  styleUrls: ['./message-history-image-viewer.component.scss'],
})
export class MessageHistoryImageViewerComponent implements OnInit, OnDestroy {
  messageRecipientId: number;
  messageId: number;
  messageRecipient$: Observable<MessageRecipient>;
  messageRecipientSubscription: Subscription;
  message: Message;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private routerExtension: RouterExtensionService,
    private store$: Store<MessagesState>
  ) {}

  ngOnInit(): void {
    this.route.params.forEach((params: Params) => {
      this.messageRecipientId = +params['messageRecipientId'];
      this.messageId = +params['messageId'];
    });

    this.messageRecipient$ = this.store$.select(
      selectMessageRecipientById(this.messageRecipientId)
    );

    this.messageRecipientSubscription = this.messageRecipient$.subscribe(
      (mr: MessageRecipient) => {
        this.message = mr.message_set.messages.find(
          (message: Message) => message.id === this.messageId
        );
      }
    );
  }

  ngOnDestroy() {
    this.messageRecipientSubscription.unsubscribe();
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown($event: KeyboardEvent) {
    if (
      $event.keyCode === ASCII_REMOTE_KEYS.back ||
      $event.keyCode === ASCII_REMOTE_KEYS.blue
    ) {
      this.onBackPressed($event);
    }
    return false;
  }

  onBackPressed($event) {
    console.log('back pressed!');
    this.router.navigate([this.routerExtension.previousRoutePath.value]);
  }
}
